<template>
    <div>
        <MercenaryHeader :title="'코치 등록 및 정보'" :back-title="'활동 및 설정'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <div style="flex:1; padding:12px; background-color: #f5f5f5;">
            <div class="title" style="margin-top:20px;">알림</div>
            <div class="container" style=" display:flex;">
                <div style="flex:1;">
                    <div class="label">사용자 유형</div>
                    <div class="contents">{{is_coach ? '코치 회원' : '일반 회원'}}</div>
                </div>
                <div style="width:20px; display:grid; place-items: center;" >
                    <img v-if="is_coach" :src="require('@/assets/images/coach_register/coach_regi_is_coach.png')" style="width:24px; height:24px;">
                    <img v-else :src="require('@/assets/images/member_talk/member_talk_grade_iron.png')" style="width:24px; height:24px;">
                </div>
            </div>

            <div class="title" style="margin-top:20px;">코치정보</div>
            <div class="container" >
                <div style="">
                    <div class="label">선수 정보</div>
                    <div class="contents" v-if="career_history.length > 0">
                        <div v-for="each, i in career_history" :key="i" class="career_history_each">
                            <div style="display:flex;">
                                <div style="flex:1;" class="career_history_team_name">{{each.team_name}}</div>
                                <div class="career_history_del_btn" @click="deleteCareer(each.idx)">삭제</div>
                            </div>
                            <div style="margin-top:5px;" class="career_history_info">{{each.role}} · {{each.join_date | dotToYearMonth}} ~ {{each.exit_date | dotToYearMonth}}</div>
                        </div>
                    </div>
                    <div class="contents" v-else>선수 이력 없음</div>
                </div>
                <div class="horizontal_line"></div>
                <div class="btn" :style="{color: is_coach ? '#699BF7': ''}" @click="showCoachCareerRegister">{{career_history.length > 0 ? '선수 이력 추가하기' : '선수 이력 등록하기'}}</div>
            </div>

            <div class="container" style="margin-top:10px;">
                <div style="">
                    <div class="label">코치 자격증</div>
                    <div class="contents"><span>{{coach_cert_doc_display ? coach_cert_doc_display : '정보 없음'}}</span><img v-if="coach_cert_doc_display" :src="require('@/assets/images/coach_register/coach_regi_confirmed.png')" style="width:14px; height:14px;"></div>
                </div>
                <div class="horizontal_line"></div>
                <div class="btn" :style="{color: is_coach ? '#699BF7': ''}" @click="showCoachCertRegister">{{is_coach_cert_sent ? '변경 요청하기' : '코치 자격증 등록하기'}}</div>
            </div>

            <div v-if="!is_coach" class="container" style="display:grid;place-items: center; height:48px; font-weight:bold; font-size:14px;" :style="{color : is_sent ? '' : 'var(--color-main)'}" @click="showCoachDocRegister">{{is_sent ? '코치 등록중...' : '코치 등록하기'}}</div>
        </div>
    </div>
</template>

<script>
    import MercenaryHeader from "../../common/MercenaryHeader";
    import {COACH_DOC_COMPLETE} from "./CoachDocComplete";
    import ResponseCode from "../../../ResponseCode";

    export default {
        name: "CoachRegister",
        components: {MercenaryHeader},
        computed : {
            is_coach(){
                return this.$GlobalStore.loginInfo().is_coach == '1';
            }
        },
        data(){
            return {
                is_sent : false,
                career_history : [],
                career_period_str : null,
                coach_cert_doc_display : null,
                is_coach_cert_sent : false,
            }
        },
        methods : {
            async deleteCareer(idx){
                const html = `<div style="color: #210F03; padding: 20px 0px 20px 0px; border-bottom:1px solid #EBEBEB; font-weight:bold; font-size:16px;">이력 삭제</div><div style="padding:0px 15px; line-height: 20px; font-size:14px; padding-bottom:15px;"><br>이력을 삭제하시겠습니까?</div>`;
                this.$GlobalStore.showConfirm(html, async () => {
                    const parameters = {};
                    parameters.idx = idx;
                    const res = await this.$Axios.post('/api/member/career_history/delete', parameters);
                    if(res.data.code === ResponseCode.SUCCESS){
                        this.refresh();
                    }else if(res.data.code === ResponseCode.FAIL){
                        this.$GlobalStore.showAlert(res.data.msg);
                    }
                }, '삭제하기', '취소하기', this.$GlobalStore.CONFIRM_TYPE.VERSION5, false, () => {})
            },
            showCoachCareerRegister(){
                if(!this.is_coach) return;
                this.$Util.sendEventClick('코치등록및정보_이력등록');
                this.$GlobalStore.addModal('CoachCareerRegister', {transitionName : 'bottom', completeAction : () => {this.refresh()}});
            },
            showCoachCertRegister(){
                if(!this.is_coach) return;
                this.$Util.sendEventClick('코치등록및정보_코치자격증등록');
                this.$GlobalStore.addModal('CoachCertRegister', {transitionName : 'bottom', completeAction : () => {this.refresh()}});
            },
            showCoachDocRegister(){
                if(this.is_sent){
                    this.$GlobalStore.addModal('CoachDocComplete', {type : COACH_DOC_COMPLETE.PROGRESSING});
                }else {
                    this.$Util.sendEventClick('코치등록및정보_코치등록');
                    this.$GlobalStore.addModal('CoachRegisterExplanation', {step : 0, closeAction : () => {this.refresh();}, transitionName : 'bottom'});
                }
            },
            async checkSent() {
                const res = await this.$Axios.get('/api/player_cert/check/sent');
                if (res.data.is_sent) {
                    this.is_sent = true;
                }

                if (res.data.is_coach_cert_sent) this.is_coach_cert_sent = true;
            },
            async getCareerHistory(){
                const parameters = {}
                const res = await this.$Axios.get('/api/member/career_history', {params : parameters});
                this.career_history = res.data.career_history;
                this.career_period_str = res.data.career_period_str;
                this.coach_cert_doc_display = res.data.coach_cert_doc_display;
            },
            refresh(){
                this.checkSent();
                if(this.is_coach){
                    this.getCareerHistory();
                }
            }
        },
        created(){
            this.refresh();
        }
    }
</script>

<style scoped>
    .title{color:#210F03; font-size:16px; margin-bottom:10px; font-weight:500; }
    .container{background-color:white; border-radius:12px; padding:12px;}
    .label{font-size:14px; font-weight:bold; color:#210F03}
    .contents{margin-top:8px; font-size:14px; font-weight:500; color: #210F03; }
    .container + .container{margin-top:10px;}
    .horizontal_line{height:1px; background-color: #EBEBEB; margin:12px 0px;}
    .save_btn{background-color:#f5f5f5; display:grid; place-items: center; border-radius:12px; height:48px; color:#D9D9D9;}
    .save_btn.active{color:#210F03;}
    .btn{color:#BBBBBB; font-size:14px; font-weight:400;}
    .career_history_each{}
    .career_history_each + .career_history_each{margin-top:15px;}
    .career_history_team_name{color:#210F03; font-size:14px; font-weight:500;}
    .career_history_info{color:#606060; font-size:12px; font-weight:500;}
    .career_history_del_btn{color:#699BF7; font-size:14px; font-weight:500;}
</style>